$(document).ready(function () {
    let ajaxLockActive = false;

    const ajaxPath = '/action/voucher';
    const ajaxPathExpiresDate = 'expires-date';
    const ajaxPathBulkDeactivation = 'bulk-deactivation';
    const ajaxPathExportExcel = 'excel';
    const ajaxPathExportPdf = 'pdf';
    const page = $('#chart_content');
    const alertTarget = '#voucher_alert';
    const errorTitle = page.attr('data-error-title');

    function syncExpirySaveButton(inputElement) {
        const input = $(inputElement);
        const button = input.closest('.voucher_expires_date').find('.voucher_edit_expires_date_btn');
        const oldValue = (input.attr('data-old-value') || '').trim();

        button.toggleClass('hidden', oldValue === input.val().trim());
    }

    function initVoucherFlatpickr() {
        if (typeof flatpickr !== 'function') {
            return;
        }

        $('#datepicker_date_from_vouchers, #datepicker_date_to_vouchers').each(function () {
            if (this._flatpickr) {
                return;
            }

            flatpickr(this, {
                dateFormat: 'd/m/Y',
                allowInput: false,
                disableMobile: true
            });
        });

        $('#active_vouchers_table .voucher_edit_expires_date_input').each(function () {
            if (this._flatpickr) {
                return;
            }

            flatpickr(this, {
                dateFormat: 'd/m/Y',
                allowInput: false,
                disableMobile: true,
                onChange: function (selectedDates, dateText, instance) {
                    syncExpirySaveButton(instance.input);
                }
            });
        });
    }

    initVoucherFlatpickr();

    const storedAlert = sessionStorage.getItem('voucherAlert');
    if (storedAlert) {
        sessionStorage.removeItem('voucherAlert');

        try {
            const alert = JSON.parse(storedAlert);
            displayTailwindAlert(alert.title, alert.message, alertTarget, alert.type);
        } catch (error) {
            // Ignore malformed storage values left by an interrupted request.
        }
    }

    $(document).on('change', '#active_vouchers_table .voucher_edit_expires_date_input', function () {
        syncExpirySaveButton(this);
    });

    $(document).on('click', '#active_vouchers_table .voucher_edit_expires_date_btn', function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (ajaxLockActive) {
            return false;
        }

        showPreloader();
        ajaxLockActive = true;

        const button = $(this);
        const voucherNumber = button.attr('data-voucher-number');
        const row = button.closest('tr');
        const input = button.closest('.voucher_expires_date').find('.voucher_edit_expires_date_input');

        $.ajax({
            type: 'POST',
            url: `${ajaxPath}/${voucherNumber}/${ajaxPathExpiresDate}`,
            data: {
                expires_date: input.val()
            },
            dataType: 'json'
        }).done(function (data) {
            input.attr('data-old-value', input.val());
            row.toggleClass('bg-danger/10', data.is_expired === true);
            button.addClass('hidden');

            displayTailwindAlert(
                page.attr('data-expiry-updated-title'),
                page.attr('data-expiry-updated-message'),
                alertTarget,
                'success'
            );
        }).fail(function (data) {
            displayTailwindAlert(
                errorTitle,
                extractErrorMessage(data, page.attr('data-expiry-update-error')),
                alertTarget,
                'error'
            );
        }).always(function () {
            ajaxLockActive = false;
            hidePreloader();
        });

        return false;
    });

    $('#show_deactivated_vouchers').on('click', function (event) {
        event.preventDefault();

        const button = $(this);
        const table = $('#deactivated_vouchers');
        const shouldShow = table.hasClass('hidden');

        table.toggleClass('hidden', !shouldShow);
        button.text(shouldShow ? button.attr('data-hide-label') : button.attr('data-show-label'));

        return false;
    });

    $('#deactivate_vouchers').on('click', function (event) {
        event.preventDefault();

        const inputs = $('#active_vouchers_table input[name="vouchers_deactivate[]"]:checked');
        if (!inputs.length) {
            displayTailwindAlert(
                errorTitle,
                page.attr('data-no-selection-error'),
                alertTarget,
                'error'
            );
            return false;
        }

        if (ajaxLockActive) {
            return false;
        }

        const voucherNumbers = inputs.map(function () {
            return $(this).attr('data-voucher-number');
        }).get().filter(Boolean);

        showPreloader();
        ajaxLockActive = true;

        $.ajax({
            type: 'POST',
            url: `${ajaxPath}/${ajaxPathBulkDeactivation}`,
            data: {
                voucher_numbers: voucherNumbers
            },
            dataType: 'json'
        }).done(function () {
            sessionStorage.setItem('voucherAlert', JSON.stringify({
                title: page.attr('data-deactivated-title'),
                message: page.attr('data-deactivated-message'),
                type: 'success'
            }));
            window.location.reload();
        }).fail(function (data) {
            displayTailwindAlert(
                errorTitle,
                extractErrorMessage(data, page.attr('data-bulk-deactivate-error')),
                alertTarget,
                'error'
            );
        }).always(function () {
            ajaxLockActive = false;
            hidePreloader();
        });

        return false;
    });

    $('#export_deactivated_vouchers_excel').on('click', function (event) {
        event.preventDefault();

        if (ajaxLockActive) {
            return false;
        }

        showPreloader();
        ajaxLockActive = true;

        $.ajax({
            type: 'GET',
            url: `${ajaxPath}/${ajaxPathExportExcel}`,
            data: {
                date_from: $('#datepicker_date_from_vouchers').val(),
                date_to: $('#datepicker_date_to_vouchers').val()
            },
            dataType: 'json'
        }).done(function (data) {
            window.location = '/includes/report/excels/' + data.excel_file_name;
        }).fail(function (data) {
            displayTailwindAlert(
                errorTitle,
                extractErrorMessage(data, page.attr('data-export-excel-error')),
                alertTarget,
                'error'
            );
        }).always(function () {
            ajaxLockActive = false;
            hidePreloader();
        });

        return false;
    });

    $('#export_deactivated_vouchers_pdf').on('click', function (event) {
        event.preventDefault();

        if (ajaxLockActive) {
            return false;
        }

        showPreloader();
        ajaxLockActive = true;

        const params = new URLSearchParams({
            date_from: $('#datepicker_date_from_vouchers').val(),
            date_to: $('#datepicker_date_to_vouchers').val()
        });

        fetch(`${ajaxPath}/${ajaxPathExportPdf}?${params.toString()}`, {
            method: 'GET'
        }).then(function (response) {
            if (!response.ok) {
                throw new Error(page.attr('data-export-pdf-error'));
            }
            return response.blob();
        }).then(function (blob) {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');

            link.href = url;
            link.download = 'deaktiverte_tilgodelapper_rapport.pdf';
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        }).catch(function (error) {
            displayTailwindAlert(
                errorTitle,
                error.message || page.attr('data-export-pdf-error'),
                alertTarget,
                'error'
            );
        }).finally(function () {
            ajaxLockActive = false;
            hidePreloader();
        });

        return false;
    });

    function extractErrorMessage(data, defaultMessage) {
        if (!data || !data.responseText) {
            return defaultMessage;
        }

        try {
            const parsed = JSON.parse(data.responseText);
            return parsed && parsed.error_message ? parsed.error_message : defaultMessage;
        } catch (error) {
            return defaultMessage;
        }
    }
});
